<template>
  <tile class='opc-succezz__partner' v-if='successMsgForPartnership'>
    <template v-if="newSuccessVersion">
      <div class='opc-succezz__partner--new-content' v-html="successMsgForPartnership" />
    </template>
    <template v-else>
      <span class='opc-succezz__partner--icon'>{{ $t('billing.partner.special_offer') }}</span>
      <span v-html='successMsgForPartnership' class='opc-succezz__partner--content' />
    </template>
  </tile>
</template>
<script>
import Tile from '@/components/tile.vue';
import { safeJSONParse } from '@/utils';
import successPartnerPromoteMixin from '@/views/config/partner-refer/mixin/success-partner-promote';

export default {
  components: {Tile},
  mixins: [successPartnerPromoteMixin],
  props: {
    partnerReferJsonString: String,
  },
  computed: {
    partnerRefer() {
      return this.partnerReferJsonString ? safeJSONParse(this.partnerReferJsonString, {}) : {};
    },
  },
};
</script>
<style lang='scss'>
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';
.opc-succezz{
  &__partner {
    display: flex;
    align-items: flex-start;
    padding: 23px;
    margin-top: 25px;
    margin-bottom: 45px;
    width: 620px;
    flex-direction: column;

    @include media(mobile, tablet) {
      width: auto;
      padding: 16px 20px;
      margin-top: 16px;
    }

    &--icon {
      background: linear-gradient(96.59deg, #084845 10.36%, #09a639 89.64%);
      font-family: 'SF Pro', 'Almaden Sans';
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      padding: 0px 4px;
      color: #ffffff;
      border-radius: 100px;
      white-space: nowrap;
      height: 16px;
      margin-right: 6px;
      margin-bottom: 4px;
    }

    &--content {
      font-weight: 450;
      font-size: 16px;
      line-height: 150%;
      color: #222230;
      margin: 0px;
    }

    &--new-content {
      display: flex;
    }
  }
}
</style>
